import Slide from '@mui/material/Slide'
import IconButton from '@mui/material/IconButton'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import { Box } from '@mui/material'

interface MakeshiftDrawerProps {
  open: boolean
  handleSidebarCollapse: () => void
  sidebar: React.JSX.Element
  collapseDisabled?: boolean
}

export default function MakeshiftDrawer({
  open,
  handleSidebarCollapse,
  sidebar,
  collapseDisabled,
}: MakeshiftDrawerProps) {
  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      {collapseDisabled ? (
        <Box sx={{ mb: 2 }} />
      ) : (
        <Box
          sx={{
            justifyContent: 'flex-end',
            display: 'flex',
            textTransform: 'none',
            color: 'grey.500',
          }}
        >
          <IconButton
            sx={{
              alignSelf: 'right',
              fontSize: '1rem',
              '&:hover': { backgroundColor: 'transparent' },
            }}
            onClick={() => handleSidebarCollapse()}
          >
            {open ? <ChevronLeftIcon /> : <ChevronRightIcon />}
          </IconButton>
        </Box>
      )}
      <Slide direction="right" in={open || collapseDisabled} mountOnEnter unmountOnExit>
        <Box sx={{ width: '100%', height: '100%', bgcolor: 'background.paper' }}>{sidebar}</Box>
      </Slide>
    </Box>
  )
}
